(() => {
  function init(root = document) {
    const sections = [...root.querySelectorAll('[data-customer-reviews]')];
    if (root.matches?.('[data-customer-reviews]')) sections.unshift(root);
    sections.forEach(section => {
      if (section.dataset.reviewsReady) return;
      section.dataset.reviewsReady = 'true';
      const cards = [...section.querySelectorAll('[data-review-card]')];
      const button = section.querySelector('[data-reviews-more]');
      const all = section.querySelector('[data-reviews-all]');
      const status = section.querySelector('[data-reviews-status]');
      function update() {
        const remaining = cards.filter(card => card.hidden).length;
        button.hidden = remaining === 0;
        all.hidden = remaining !== 0;
        if (remaining) button.textContent = `Show ${Math.min(4, remaining)} more reviews`;
      }
      button.addEventListener('click', () => {
        const next = cards.filter(card => card.hidden).slice(0, 4);
        next.forEach(card => { card.hidden = false; });
        button.setAttribute('aria-expanded', 'true');
        update();
        status.textContent = `${cards.filter(card => !card.hidden).length} of ${cards.length} selected reviews shown.`;
        next[0]?.querySelector('h3')?.focus({ preventScroll: true });
      });
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
